import React, { useState } from 'react'
import CustomTooltip from '../../../../components/common/customToolptip'
import Box from '@mui/material/Box'
import HelpIcon from '../../../../icons/helpIcon'
import { SxProps, Theme, useMediaQuery, useTheme, Modal, Typography, IconButton, Paper } from '@mui/material'
import CloseIcon from '../../../../icons/closeIcon'
interface Props {
  sx?: SxProps<Theme> 
}

const content = (
  <>
    <p>Le rôle Utilisateur permet de :</p>
    <ul>
      <li>Se connecter</li>
      <li>Accéder à son profil, les événements et formations auquels il est inscrit</li>
    </ul>
    <p>Le rôle Administratif permet de:</p>
    <ul>
      <li>Ajouter/modifier un contact/utilisateur</li>
      <li>Voir les contacts/utilisateurs</li>
      <li>Voir l’historique d’activité</li>
    </ul>
    <p>Le rôle Financier permet de:</p>
    <ul>
      <li>Voir les factures</li>
      <li>Payer les factures</li>
    </ul>
    <p>Le rôle d’achat permet de:</p>
    <ul>
      <li>S’inscrire à des événements et formations</li>
      <li>
        Effectuer d’autres achats en ligne (portés au compte lorsque les articles le permettent)
      </li>
    </ul>
    À noter que pour inscrire plusieurs participants à une formation ou un événement, l'utilisateur
    devra avoir les rôles Administratif et Achat.
  </>
)
const TooltipRole = ({sx}:Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(800))
  const [openModal, setOpenModal] = useState(false)
  
  const handleClick = () => {
    if (isMobile) {
      setOpenModal(true)
    }
  }
  
  const handleCloseModal = () => {
    setOpenModal(false)
  }
  
  if (isMobile) {
    return (
      <>
        <Box
          onClick={handleClick}
          sx={{
            cursor: 'pointer',
            '&:hover svg path': {
              fill: '#5F686A',
            },
            ...sx
          }}
          component='span'
        >
          <HelpIcon />
        </Box>
        
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="roles-info-title"
        >
          <Paper
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '90%',
              maxWidth: '500px',
              maxHeight: '80vh',
              overflow: 'auto',
              p: '24px',
              borderRadius: '8px',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '16px' }}>
              <Typography id="roles-info-title" variant="h6" component="h2">
                Information sur les rôles
              </Typography>
              <IconButton onClick={handleCloseModal} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
            <Box sx={{ 
              '& p': { mb: '12px', fontSize: '14px' },
              '& ul': { mb: '16px', pl: '20px' },
              '& li': { mb: '4px', fontSize: '14px' }
            }}>
              {content}
            </Box>
          </Paper>
        </Modal>
      </>
    )
  }
  
  return (
    <CustomTooltip 
      title={<React.Fragment>{content}</React.Fragment>} 
      placement='right'
      arrow
    >
      <Box
        sx={{
          cursor: 'pointer',
          '&:hover svg path': {
            fill: '#5F686A',
          },
          ...sx
        }}
        component='span'
        className='tooltip'
      >
        <HelpIcon />
      </Box>
    </CustomTooltip>
  )
}

export default TooltipRole
